/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostSaveConfigurationMutationRequest, PostSaveConfigurationMutationResponse, PostSaveConfigurationQueryParams, PostSaveConfiguration400 } from "../../models/PostSaveConfiguration";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPostSaveConfigurationUrl() {
  const res = { method: 'POST', url: `/api/v1/configurations` as const }  
  return res
}

/**
 * {@link /api/v1/configurations}
 */
export async function postSaveConfiguration({ data, params }: { data: PostSaveConfigurationMutationRequest; params?: PostSaveConfigurationQueryParams }, config: Partial<RequestConfig<PostSaveConfigurationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostSaveConfigurationMutationResponse, ResponseErrorConfig<PostSaveConfiguration400>, PostSaveConfigurationMutationRequest>({ method : "POST", url : getPostSaveConfigurationUrl().url.toString(), params, data : requestData, ... requestConfig })  
  return res.data
}